import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { AppState } from 'services/types';
import { updateQueryString } from '../../../../services/router/actions';

// Components
// @ts-ignore
import CurrentSeasonInProgressGate from '../../../../components/CurrentSeasonInProgressGate';


// Selectors
// @ts-ignore
import { makeSelectOptions } from './selectors';
import { SCHEMA_CATEGORY_CHECKLIST } from '../../../../services/schemas/constants';
import { CHECKLIST_TYPE_MODAL } from '../ChecklistTypeModal';

// Constants
const text = 'Create Job';

interface DispatchProps {
    updateQueryString: Function;
}

interface ConnectedProps {
    options: {
        key: number,
        text: string,
        value: number
    }[];
}

type Props = DispatchProps & ConnectedProps

export class CreateGeneralEventButtonComponent extends React.PureComponent<Props> {
    handleClick = (option: Record<string, any>): void => {
        if (option.value === SCHEMA_CATEGORY_CHECKLIST) {
            this.props.updateQueryString({
                [CHECKLIST_TYPE_MODAL]: true,
                selectedEvent: undefined,
                selectedSchema: undefined
            });
        } else {
            this.props.updateQueryString({
                generalEventModal: true,
                selectedEvent: undefined,
                selectedSchema: option.value
            });
        }
    };

    render(): React.ReactElement | null {
        const { options } = this.props;

        if (!options || !options.length) return null;

        return (
            <CurrentSeasonInProgressGate>
                <Dropdown
                    direction="left"
                    floating
                    button
                    className="secondary float circular small"
                    text={text}
                    selectOnBlur={false}
                >
                    <Dropdown.Menu>
                        {options.map(option => (
                            <Dropdown.Item
                                key={option.key}
                                text={option.text}
                                onClick={(): void => this.handleClick(option)}
                            />
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    options: makeSelectOptions()
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(CreateGeneralEventButtonComponent);
